import { render } from "./BasePassword.vue?vue&type=template&id=331cb0c6&scoped=true"
import script from "./BasePassword.vue?vue&type=script&lang=js"
export * from "./BasePassword.vue?vue&type=script&lang=js"

import "./BasePassword.vue?vue&type=style&index=0&id=331cb0c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-331cb0c6"]])

export default __exports__